
import { alertController } from '@ionic/vue';
import { defineComponent, reactive } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import SimpleModal from './SimpleModal.vue';
import VueLodash from 'vue-lodash';

export default defineComponent({
  components:{ SimpleModal },
  data() {
    return {
      communityPlaylist: [],
      chartsPlaylist: [],
      eventList: [],
      imgArr: '',
      
    }
  },
 setup() {
    // const revents = [{
    //     'event_name': 'Lewis Concert'
    // }]

    const modalInfo = reactive <{ show: boolean; data: any}>({
      show: false,
      data:null
    })

    const showModal = () => {
      modalInfo.show = true;
    }

    const handleModalClosed = (eventData: any) =>{
      modalInfo.show = false
      //alert(JSON.stringify(eventData))
    }
    const router = useRouter();
 
    // Optional parameters to pass to the swiper instance. See http://idangero.us/swiper/api/ for valid options.
    const slideOpts = {
      slidesPerView: 3,
      spaceBetween: 10,
      initialSlide: 0,
      speed: 100,
      breakpoints: {
        // when window width is >= 320px
        320: {
        slidesPerView: 2,
        spaceBetween: 0
        },
        // when window width is >= 480px
        768: {
        slidesPerView: 3,
        spaceBetween: 30
        },
        // when window width is >= 640px
        1024: {
        slidesPerView: 5,
        spaceBetween: 0
        }
    }
    };

    return { handleModalClosed, modalInfo, showModal, slideOpts, router }
  },
  methods: {
    redirect(id: string){
      console.log("CLICKED");
        this.router.push('/music/recommended/p/' + id);
    },
    getPlaylistDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    },
    getChartsDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    },
      openEvent(uri: string){
    window.open(uri,'name','width=500,height=700')
    },
        // getImage(search: string){
        //     // const imgURL = "wneongewn.ewonfewn.cwe" + Math.random()

        //     // this.getImageSearch(search).then(data => {
        //     //     //console.log(data.artists.items[0].images[0]); // JSON data parsed by `data.json()` call
        //     //     this.imgArr += "," + data.artists.items[0].images[0].url
        //     //     return data.artists.items[0].images[0].url

        //     // })
        //     // console.log(this.imgArr)
        //     return ""
        // },


    // async getImageSearch(search: string) {
    //             const url= `https://api.spotify.com/v1/search?q=` + encodeURI(search || '') + `&type=artist`;
    //             const usertoken = localStorage.getItem("accesstoken");
    //             const response = await fetch(url, {
    //                 method: 'GET',
    //                 headers: {
    //                 'Authorization': 'Bearer ' + usertoken,
    //                 // 'Content-Type': 'application/x-www-form-urlencoded',
    //                 },
    //                 redirect: 'follow', // manual, *follow, error
    //                 referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //                 // body: JSON.stringify(data) // body data type must match "Content-Type" header
    //             });
    //             return response.json(); // parses JSON response into native JavaScript objects
    //     },




    //   const data = (await res.json());
    //     console.log(data.artists.items[0].images[0].url)

    //     if(data.artists.items[0].images[0].url !== undefined){
    //         console.log(data.artists.items[0].images[0].url)
    //         return JSON.stringify(data.artists.items[0].images[0].url)
    //     }else{
    //         return "https://lastfm.freetls.fastly.net/i/u/300x300/2a96cbd8b46e442fc41c2b86b821562f.png"
    //     }
 
   //},


//    async getImage(search: string) {
//     const usertoken = localStorage.getItem("accesstoken")

//       await fetch( `https://api.spotify.com/v1/search?q=` + encodeURI(search || '') + `&type=artist`, { 'headers': {'Authorization': 'Bearer ' + usertoken }}).then(res=>{
//             const data = res.json()
//             console.log(data)
//             return data
            
//       })




//     //   const data = (await res.json());
//     //     console.log(data.artists.items[0].images[0].url)

//     //     if(data.artists.items[0].images[0].url !== undefined){
//     //         console.log(data.artists.items[0].images[0].url)
//     //         return JSON.stringify(data.artists.items[0].images[0].url)
//     //     }else{
//     //         return "https://lastfm.freetls.fastly.net/i/u/300x300/2a96cbd8b46e442fc41c2b86b821562f.png"
//     //     }
 
//    },
  
  },
  created() {
    const usertoken = localStorage.getItem("accesstoken")
    console.log("OOOOK")

    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getAllPlaylist')
          .then(
              res => {
                const dataOne = res.data
                const dataTwo = dataOne.slice();
                this.communityPlaylist = dataOne
                this.chartsPlaylist = dataTwo.sort((a: Record<string, any>, b: Record<string, any>) => (b.noOfExports > a.noOfExports) ? 1 : -1)
              });


        window.addEventListener('playlist-deleted', event => {
       axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getAllPlaylist')
      .then( res => {
                
                const dataOne = res.data
                const dataTwo = dataOne.slice();
                this.communityPlaylist = dataOne
                this.chartsPlaylist = dataTwo.sort((a: Record<string, any>, b: Record<string, any>) => (b.noOfExports > a.noOfExports) ? 1 : -1)
                
              });


                             const userpid = localStorage.getItem("userID")
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/GetMostPopularArtist2?userId=' + userpid) //For events
      .then(
          res => {  
             
         
            
              this.eventList = res.data.resultsPage.results}).then(data=>{

                console.log(this.eventList)
              })

          
              });
                  const userpid = localStorage.getItem("userID")
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/GetMostPopularArtist2?userId=' + userpid) //For events
      .then(
          res => {  
             
         
            
              this.eventList = res.data.resultsPage.results}).then(data=>{

                console.log(this.eventList)
              })






    window.addEventListener('userID-Added', event => {

    const userpid = localStorage.getItem("userID")
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/GetMostPopularArtist2?userId=' + userpid) //For events
      .then(
          res => {  
             
           
            console.log(res.data.resultsPage.results)
              this.eventList = res.data.resultsPage.results}).then(data=>{

                console.log(this.eventList)
              })

          
              })
   


    
  }, 


     
});
